import React from 'react';
import styled from 'styled-components';
import useInterviewType from '../hooks/useInterviewType';

import type { MiniInterviewType } from 'src/packages/polaris/types';

export const BodyText = styled.p`
  ${(props) => props.theme.typography.variants.secondary.main};
  margin-top: 1rem;
`;

export const Header = styled.h3`
  padding-right: 30px;
  ${(props) => props.theme.typography.variants.primary.large};
  margin: 0;
`;

const getDisclaimerText = (interviewType: MiniInterviewType | null) => {
  switch (interviewType) {
    case 'treatment':
      return 'Our treatment quiz leverages experimental AI technology. This quiz is for informational purposes only and is not a substitute for professional medical advice. If you are having an emergency, call 911 or your local emergency service.';
    default:
      return "We're developing a shorter version of Buoy's original AI technology that uses high-quality medical data and questions to understand your condition quickly. This is for informational purposes only and not a substitute for professional medical advice. If it's an emergency, call 911 or your local emergency service.";
  }
};

const DisclaimerModal = () => {
  const interviewType = useInterviewType();

  return (
    <div>
      <Header>Meet Buoy</Header>
      <BodyText>{getDisclaimerText(interviewType)}</BodyText>
    </div>
  );
};

export default DisclaimerModal;
